import { gql } from 'apollo-angular';

export const articles = gql`
	fragment Articles on ArticleOutput {
		id
		updateTimestamp
		localizations {
			title
			locale
			content
			videoId
			pictureUrl
		}
	}
`;
